/* eslint-disable react-hooks/exhaustive-deps */
// react
import queryString from "query-string"
import { useEffect, useState, useRef } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"

// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import { AppDispatch } from "../../.."
import dayjs from "dayjs"

// Kairos
import AlertComponent from "../../../components/AlertComponent"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import { showInfoToast } from "../../../components/CustomToast"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import ComboBox from "../../../components/ComboBox"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import { RootState } from "../../../globalStore/rootreducer"
import { TApiResponse } from "../../../service/TApiResponse"
import KadaiKentoKaigiService from "../../../service/budget/kadaiKentoKaigi/kadaiKentoKaigiService"
import {
  TWeeklyReportBusyoListGetReq,
  TWeeklyReportBusyoListPutReq,
  TWeeklyReportBusyoMicomiPutReq,
  TWeeklyReportPrintReq,
  T週報部所,
} from "../../../service/budget/kadaiKentoKaigi/TKadaiKentoKaigi"
import { 予算_実績メニューコード } from "../../../constant/menuCode"
import util from "../../../ts/util"
import { quotOrZero } from "../../../ts/util/decimalUtil"
import BusyoService from "../../../service/master/busyo/busyoService"
import { cnvUriageStr } from "./WeeklyReportAllList"
import Decimal from "decimal.js"
import { 部所週次業績月合計行作成 } from "./kadaiKentoKaigiUtil"

type T売上見込 = {
  年月: string
  見込: string
  売上予算ID: number
  項目: string
  金額: string
  見込事由?: string
  更新日時?: string
  modifyTaken?: string
}

/**
 * 業績会議　週報部所別
 * @returns
 */
const WeeklyReportBusyoList = () => {
  const disPatch: AppDispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const 当営業日 = useSelector((state: RootState) => state.date.eigyobiStr)
  const isPrompt = useRef(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "WeeklyReportBusyoList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        // 予算実績行の数値と達成率行のパーセンテージを表示するため文字列に変換
        金額str: (i: T週報部所) => cnvUriageStr(i.金額, i.項目),
      },
    })

  /**
   * 合計collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createMikomiCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TWeeklyReportBusyoListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TWeeklyReportBusyoListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const allListRes = await new KadaiKentoKaigiService().getList(
        currentSearchCondition
      )
      const yosanRes = await new KadaiKentoKaigiService().getYosan(
        currentSearchCondition
      )
      setPrevSearchCondition(currentSearchCondition)
      const resData: T週報部所[] = allListRes.data
      const yosanData = yosanRes.data
      resData.sort((a, b) => {
        if (a.週番号 > b.週番号) return 1
        if (a.週番号 < b.週番号) return -1
        return 0
      })
      // 日数を算出
      const 日数: number[] = []
      const firstDay = dayjs(dayjs(年月 ?? 当営業日).format("YYYY/MM/") + "01")
      const dayCount = firstDay.daysInMonth()
      const firstWeekCount = 7 - firstDay.day()
      let 日数Sum = firstWeekCount
      日数.push(firstWeekCount)
      do {
        if (日数Sum + 7 < dayCount) {
          日数.push(7)
          日数Sum = 日数Sum + 7
        } else {
          日数.push(dayCount - 日数Sum)
          日数Sum = 日数Sum + 7
        }
      } while (日数Sum < dayCount)

      const d = resData.reduce((result: T週報部所[], current) => {
        if (current.週番号 != null) {
          const 週番号Num = Number(current.週番号)
          if (日数.length >= 週番号Num) {
            current.日数 = 日数[週番号Num - 1]
          }
        }
        result.push(current)
        return result
      }, [])
      // 達成率を作成
      const gridRowData = d.reduce((result: T週報部所[], current) => {
        const yosan = result.find(
          (r) => r.週番号 === current.週番号 && r.項目 === "予算"
        )
        if (
          yosan &&
          yosan.週番号 === current.週番号 &&
          current.項目 === "実績"
        ) {
          result.push(current)
          const tassei: T週報部所 = {
            週次業績報告ID: yosan.週次業績報告ID,
            週番号: yosan.週番号,
            年月: yosan.年月,
            日数: yosan.日数,
            所属部所名: yosan.所属部所名,
            所属部所コード: yosan.所属部所コード,
            項目: "達成率",
            金額: quotOrZero(current.金額, yosan.金額),
            報告テキスト１: current.報告テキスト１,
            報告テキスト２: current.報告テキスト２,
          }
          result.push(tassei)
        } else {
          result.push(current)
        }
        return result
      }, [])

      // 月合計を作成
      const 月間予算 = yosanData.予算額

      const 月間実績 = gridRowData
        .filter((d) => d.項目 === "実績")
        .map((d) => d.金額)
        .reduce((a, b) => a.plus(b ?? 0), new Decimal(0))
        .toNumber()

      const 月間達成率 = quotOrZero(月間実績, 月間予算)

      const 月間運行実績 = gridRowData
        .filter((d) => d.項目 === "運行実績")
        .map((d) => d.金額)
        .reduce((a, b) => a.plus(b ?? 0), new Decimal(0))
        .toNumber()

      // 先頭部所のみなのでdataの先頭情報より内容を取得
      const 予算情報 = gridRowData[0]

      gridRowData.push(部所週次業績月合計行作成(予算情報, "予算", 月間予算))
      gridRowData.push(部所週次業績月合計行作成(予算情報, "実績", 月間実績))
      gridRowData.push(部所週次業績月合計行作成(予算情報, "達成率", 月間達成率))
      gridRowData.push(
        部所週次業績月合計行作成(予算情報, "運行実績", 月間運行実績)
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(gridRowData, pageSize) })

      const mikomiGridData: T売上見込[] = []

      mikomiGridData.push({
        年月: currentSearchCondition?.年月 ?? "",
        見込: "見込",
        売上予算ID: yosanData.売上予算ID,
        項目: "予算",
        金額: cnvUriageStr(yosanData.予算額 ?? 0, "予算"),
        見込事由: yosanData.見込事由,
        更新日時: yosanData.更新日時,
      })
      mikomiGridData.push({
        年月: currentSearchCondition?.年月 ?? "",
        見込: "見込",
        売上予算ID: yosanData.売上予算ID,
        項目: "見込実績",
        金額: cnvUriageStr(yosanData.見込額 ?? 0, "実績"),
        見込事由: yosanData.見込事由,
        更新日時: yosanData.更新日時,
      })
      mikomiGridData.push({
        年月: currentSearchCondition?.年月 ?? "",
        見込: "見込",
        売上予算ID: yosanData.売上予算ID,
        項目: "達成率",
        金額: cnvUriageStr(
          quotOrZero(yosanData.見込額 ?? 0, yosanData.予算額),
          "達成率"
        ),
        見込事由: yosanData.見込事由,
        更新日時: yosanData.更新日時,
      })

      // 見込み欄に運行実績を出すために上で取得した実績データより運行実績を合計する
      const 運行実績月間計 = resData
        .filter((d) => d.項目 === "運行実績")
        .map((d) => d.金額 ?? 0)
        .reduce((a, b) => new Decimal(a).plus(b).toNumber(), 0)

      mikomiGridData.push({
        年月: currentSearchCondition?.年月 ?? "",
        見込: "見込",
        売上予算ID: yosanData.売上予算ID,
        項目: "運行実績",
        金額: cnvUriageStr(運行実績月間計, "運行実績"),
        見込事由: yosanData.見込事由,
        更新日時: yosanData.更新日時,
      })

      setMikomiGridData({
        data: createMikomiCollectionView(mikomiGridData, pageSize),
      })
      const int当月 = parseInt(dayjs(new Date()).format("YYYYMM"))
      const int検索年月 = parseInt(
        dayjs(currentSearchCondition.年月).format("YYYYMM")
      )
      setIsSubmit(int当月 <= int検索年月)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TWeeklyReportBusyoListGetReq = queryString.parse(
      location.search
    )
    set年月(query.年月)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TWeeklyReportBusyoListGetReq => {
    return {
      年月: 年月 ?? undefined,
      部所コード: 部所コード ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TWeeklyReportBusyoListGetReq
  ) => {
    const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM")
    return {
      年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
      部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.部所コード
      )?.部所名,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set年月("")
  }

  const beginningEdit = (s: wjGrid.FlexGrid, e: wjGrid.CellRangeEventArgs) => {
    let item: T週報部所 = e.getRow().dataItem
    const 当日 = dayjs(new Date())
    const week = Math.floor((当日.date() + 12 - 当日.day()) / 7)
    const binding = e.getColumn().binding
    // 当月のみ
    const boundItem: T週報部所 = e.getRow().dataItem
    const int当月 = parseInt(dayjs(new Date()).format("YYYYMM"))
    const int検索年月 = parseInt(dayjs(boundItem.年月).format("YYYYMM"))
    if (int検索年月 < int当月) {
      e.cancel = true
      return
    }
    if (item.週番号 !== week) {
      switch (binding) {
        case "報告テキスト１":
        case "報告テキスト２":
          e.cancel = true
          break
        default:
          e.cancel = true
          break
      }
    }
  }

  const pastingCell = beginningEdit

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)
    grid.beginningEdit.addHandler(beginningEdit)
    grid.pastingCell.addHandler(pastingCell)
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    // if (e.panel === f.cells) {

    // 当日の週のみ編集可能にする
    // dayjs.day() で日:0 月:1 火:2 水:3 木:4 金:5 土:6 が返ってくる
    // 日曜日からn週目が始まるので、日曜は一週目になる日数は1のみで2~8は二週目...となり、
    // 土曜は1~7が一週目、8~14が二週目...となる
    // したがって、日曜日を起算として何週目かは、当日の日付に
    // 日:12 月:11 火:10 水:9 木:8 金:7 土:6 を足して、7で割った商で算出できる
    const 当日 = dayjs(new Date())
    const week = Math.floor((当日.date() + 12 - 当日.day()) / 7)
    const cellBinding = e.getColumn().binding
    if (cellBinding !== null && e.getRow().dataIndex !== -1) {
      const boundItem: T週報部所 = e.getRow().dataItem
      const int当月 = parseInt(dayjs(new Date()).format("YYYYMM"))
      const int検索年月 = parseInt(dayjs(boundItem.年月).format("YYYYMM"))

      let readOnlyData = true
      // 当月のみ
      if (int当月 <= int検索年月 && boundItem.週番号 === week) {
        switch (cellBinding) {
          case "週番号":
          case "日数":
          case "項目":
            break
          case "報告テキスト１":
          case "報告テキスト２":
            readOnlyData = false
            wjCore.toggleClass(e.cell, "read-only-cell", readOnlyData)
            break
          default:
            readOnlyData = true
            wjCore.toggleClass(e.cell, "read-only-cell", readOnlyData)
            break
        }
      }
    }
    // }
  }
  /**
   * 明細グリッドセル結合マネージャー
   */
  class RestrictedMergeManager extends wjGrid.MergeManager {
    getMergedRange(p: wjGrid.GridPanel, r: number, c: number, clip = true) {
      var rng = null
      rng = new wjGrid.CellRange(r, c)
      const マージ判定用bindList: { binding: string; isRequired: boolean }[] = [
        {
          binding: "週番号",
          isRequired: true,
        },
      ]
      const マージ対象bindList: string[] = [
        "週番号",
        "日数",
        "報告テキスト１",
        "報告テキスト２",
      ]
      const isMergeCell = (rowNumber: number) => {
        return !マージ判定用bindList.find((bindListItem) => {
          const cellValue = p.getCellData(r, bindListItem.binding, true)
          const prevRowValue = p.getCellData(
            rowNumber - 1,
            bindListItem.binding,
            true
          )
          if (bindListItem.isRequired && !cellValue) return true
          return cellValue !== prevRowValue
        })
      }

      // bindListの列が全て同じ値であれば結合する
      if (マージ対象bindList.includes(p.columns[c].binding ?? "")) {
        // セルの現在位置の上のセルと比較
        while (rng.row > 0 && isMergeCell(rng.row)) {
          rng.row--
        }
        // セルの現在位置の下のセルと比較
        while (rng.row2 < p.rows.length - 1 && isMergeCell(rng.row2 + 2)) {
          rng.row2++
        }
        if (rng.isSingleCell) {
          rng = null
        }
      }
      return rng
    }
  }

  const mikomiBeginningEdit = (
    s: wjGrid.FlexGrid,
    e: wjGrid.CellRangeEventArgs
  ) => {
    let item = e.getRow().dataItem as T売上見込
    const binding = e.getColumn().binding

    // 過去の年月入力は不可
    const int当月 = parseInt(dayjs(new Date()).format("YYYYMM"))
    const int検索年月 = parseInt(dayjs(item.年月).format("YYYYMM"))
    if (int当月 <= int検索年月) {
      if (item.項目 !== "見込実績") {
        switch (binding) {
          case "項目":
            e.cancel = true
            break
          default:
            break
        }
      }
    } else {
      e.cancel = true
    }
  }

  const mikomiPastingCell = mikomiBeginningEdit

  // 見込みグリッド初期化時イベントハンドラ
  const mikomiGridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(mikomiFormatItem)
    grid.beginningEdit.addHandler(mikomiBeginningEdit)
    grid.pastingCell.addHandler(mikomiPastingCell)
    grid.refresh()
  }
  /**
   * 見込みグリッドのフォーマット
   */
  const mikomiFormatItem = (
    f: wjGrid.FlexGrid,
    e: wjGrid.FormatItemEventArgs
  ) => {
    const cellBinding = e.getColumn().binding
    if (cellBinding !== null && e.getRow().dataIndex !== -1) {
      const boundItem = e.getRow().dataItem as T売上見込

      // 過去の年月入力は不可
      const int当月 = parseInt(dayjs(new Date()).format("YYYYMM"))
      const int検索年月 = parseInt(dayjs(boundItem.年月).format("YYYYMM"))
      if (cellBinding !== "見込") {
        let readOnlyData = true
        if (int当月 <= int検索年月) {
          if (boundItem.項目 === "見込実績") {
            switch (cellBinding) {
              case "金額":
                readOnlyData = false
                break
              default:
                readOnlyData = true
                break
            }
          }
          if (cellBinding === "見込事由") {
            readOnlyData = false
          }
        }
        wjCore.toggleClass(e.cell, "read-only-cell", readOnlyData)
      }
    }
  }
  /**
   * 明細グリッドセル結合マネージャー
   */
  class mikomiRestrictedMergeManager extends wjGrid.MergeManager {
    getMergedRange(p: wjGrid.GridPanel, r: number, c: number, clip = true) {
      var rng = null
      rng = new wjGrid.CellRange(r, c)
      const マージ判定用bindList: { binding: string; isRequired: boolean }[] = [
        {
          binding: "見込",
          isRequired: true,
        },
      ]
      const マージ対象bindList: string[] = ["見込", "見込事由"]
      const isMergeCell = (rowNumber: number) => {
        return !マージ判定用bindList.find((bindListItem) => {
          const cellValue = p.getCellData(r, bindListItem.binding, true)
          const prevRowValue = p.getCellData(
            rowNumber - 1,
            bindListItem.binding,
            true
          )
          if (bindListItem.isRequired && !cellValue) return true
          return cellValue !== prevRowValue
        })
      }
      // bindListの列が全て同じ値であれば結合する
      if (マージ対象bindList.includes(p.columns[c].binding ?? "")) {
        // セルの現在位置の上のセルと比較
        while (rng.row > 0 && isMergeCell(rng.row)) {
          rng.row--
        }
        // セルの現在位置の下のセルと比較
        while (rng.row2 < p.rows.length - 1 && isMergeCell(rng.row2 + 2)) {
          rng.row2++
        }
        if (rng.isSingleCell) {
          rng = null
        }
      }
      return rng
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装

    setIsConfirmModalShow(true)
  }
  /**
   * 送信
   */
  const submit = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認
      const 当日 = dayjs(new Date())
      const week = Math.floor((当日.date() + 12 - 当日.day()) / 7)

      const detailItems: T週報部所[] = gridData.data.items
      const weekleReportItem = detailItems.find(
        (d) => d.週番号 === week && d.項目 === "実績"
      )

      const MikomiItems: T売上見込[] = mikomiGridData.data.items as T売上見込[]
      let 売上予算Data: TWeeklyReportBusyoMicomiPutReq = {
        売上予算ID: 0,
        見込額: 0,
        見込事由: "",
        更新日時: "",
        modifyToken: "",
      }

      var mikomiItem = MikomiItems.find((d) => d.項目 === "見込実績")
      if (mikomiItem) {
        売上予算Data.売上予算ID = mikomiItem.売上予算ID
        売上予算Data.見込事由 = mikomiItem.見込事由 ?? ""
        if (typeof mikomiItem.金額) {
          売上予算Data.見込額 = parseInt(mikomiItem.金額.replace(",", "") ?? 0)
        }

        売上予算Data.更新日時 = mikomiItem.更新日時
      }

      if (weekleReportItem) {
        const data: TWeeklyReportBusyoListPutReq = {
          週次業績報告: weekleReportItem,
          売上予算: 売上予算Data,
        }

        const service = new KadaiKentoKaigiService()
        let res: TApiResponse<boolean>
        res = await service.putWeeklyBusyo(data)
        disPatch(setAlerts(res))
        if (res) {
          isPrompt.current = false
          // history.goBack()
          search(prevSearchCondition)
          showInfoToast(`業績会議　週報（部所）の更新が完了しました。`)
        }
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 週報業績報告帳票印刷処理
   */
  const printWeeklyReportBusyo = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    const printCondition: TWeeklyReportPrintReq = {
      抽出条件_対象年月: 年月 ?? 当営業日,
      抽出条件_部所コード: 部所コード ?? undefined,
    }
    try {
      const res = await new KadaiKentoKaigiService({
        responseType: "blob",
      }).printWeeklyReportBusyo(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }
  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(30)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 見込み用グリッド
  const [mikomiFlexGrid, setMikomiFlexGrid] = useState<wjGrid.FlexGrid>()
  const [mikomiGridData, setMikomiGridData] = useState<{
    data: wjCore.CollectionView<T売上見込>
  }>({
    data: createMikomiCollectionView([], 1),
  })

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  const [prevSearchCondition, setPrevSearchCondition] =
    useState<TWeeklyReportBusyoListGetReq>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [年月, set年月] = useState<string | null>()
  const [部所コード, set部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  // 運行場所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)
  // 更新 処理用
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  //更新可能フラグ
  const [isSubmit, setIsSubmit] = useState(false)
  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
      set年月(当営業日)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `業績会議　週報全社`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">業績会議</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="w-50rem">
              <Card.Body>
                <div>
                  <Link
                    to={
                      util.getMenuPath(
                        予算_実績メニューコード.業績会議_週報全社
                      )[0]
                    }
                    onClick={() =>
                      gridPageHelper.savePageConditionData(location.pathname)
                    }>
                    <Button disabled={isSearching}>業績報告</Button>
                  </Link>
                  <Button className="mx-2" disabled={true}>
                    部所業績報告
                  </Button>
                  <Link
                    to={
                      util.getMenuPath(
                        予算_実績メニューコード.業績会議_荷主売上一覧
                      )[0]
                    }
                    onClick={() =>
                      gridPageHelper.savePageConditionData(location.pathname)
                    }>
                    <Button disabled={isSearching}>荷主売上一覧</Button>
                  </Link>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-60rem">
              {/* CardHeaderをアコーディオン化 */}
              <Card.Header
                onClick={() => setAccordionController(!accordionController)}
                aria-controls="collapse-search-card-body"
                aria-expanded={accordionController}>
                <FontAwesomeIcon
                  icon={accordionController ? faChevronDown : faChevronUp}
                  size={"1x"}
                />
                検索条件
              </Card.Header>
              <Collapse in={accordionController}>
                <Card.Body>
                  <Form>
                    <Container fluid className="contents-search-main">
                      <Row>
                        <Col>
                          <div className="search-condition-table">
                            <div className="search-condition-row">
                              <div className="w-8rem">
                                <MonthInput
                                  id="年月"
                                  placeholder="年月"
                                  value={年月}
                                  setValue={set年月}></MonthInput>
                              </div>
                              <ComboBox.Busyo
                                placeholder="部所"
                                isLoadEnded={部所isLoadEnded}
                                setIsLoadEnded={set部所isLoadEnded}
                                isAllSelect={false}
                                isRequired={false}
                                itemsSource={部所ItemSource}
                                listFilter={(d) => d.運行部所フラグ === 1}
                                selectedValue={部所コード}
                                setSelectedValue={(v) => {
                                  set部所コード(v)
                                }}
                                ComboBox={部所ComboBox}
                                setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            </div>
                          </div>
                        </Col>
                        <Col className="text-end">
                          <Button
                            type="submit"
                            disabled={isSearching}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                              search()
                            }}>
                            <FontAwesomeIcon icon={faSearch} />
                            検索
                          </Button>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                </Card.Body>
              </Collapse>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索結果カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <Row>
                  <Col>
                    {/* 検索条件表示コンポーネント */}
                    <DisplaySearchConditionLabel
                      displaySearchCondition={displaySearchCondition}
                    />
                  </Col>
                </Row>
                <FlexGridOuter
                  flexGrid={flexGrid}
                  setFlexGrid={setFlexGrid}
                  gridProperties={{
                    allowAddNew: false,
                    allowDelete: false,
                    showMarquee:
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT.showMarquee,
                    keyActionTab:
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT.keyActionTab,
                    alternatingRowStep:
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                        .alternatingRowStep,
                    selectionMode:
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                        .selectionMode,
                    headersVisibility: wjGrid.HeadersVisibility.Column,
                    width: CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT.width,
                    mergeManager: new RestrictedMergeManager(),
                    itemFormatter: (
                      panel: wjGrid.GridPanel,
                      r: number,
                      c: number,
                      cell: HTMLElement
                    ) => {
                      if (panel.cellType === wjGrid.CellType.ColumnHeader) {
                        cell.style.textAlign = "center"
                      }
                    },
                    autoRowHeights: true,
                  }}
                  style={{ maxHeight: "auto", height: "calc(100vh - 48.5rem)" }}
                  gridData={gridData}
                  setGridData={setGridData}
                  pageNumber={pageNumber}
                  searchConditionClear={searchConditionClear}
                  gridId={`${gridId}_1`}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  isShowGridFooter={false}
                  gridInitializedHandler={gridInitializedHandler}
                  headerComponent={
                    <div>
                      <Button
                        className="btn-done"
                        disabled={
                          !gridInitialized || gridData.data.items.length === 0
                        }
                        style={{ marginLeft: "0.5rem" }}
                        onClick={(e: any) => {
                          e.stopPropagation()
                          e.preventDefault()
                          printWeeklyReportBusyo()
                        }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                        部所業績報告書印刷
                      </Button>
                    </div>
                  }>
                  <wjrGrid.FlexGridColumn
                    binding="週番号"
                    width={128}
                    isReadOnly={true}
                    align={"center"}
                    cssClass="dummy-header-cell"
                    header="週">
                    <wjrGrid.FlexGridCellTemplate
                      cellType={wjrGrid.CellTemplateType.Cell}
                      template={(
                        context: TWijmoCellTemplateContext<T週報部所>
                      ) => (
                        <>
                          {context.item.週番号 !== 99
                            ? context.item.週番号
                            : "月間"}
                        </>
                      )}></wjrGrid.FlexGridCellTemplate>
                  </wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="日数"
                    width={64}
                    isReadOnly={true}
                    cssClass="dummy-header-cell"
                    header="日数"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="項目"
                    width={100}
                    isReadOnly={true}
                    cssClass="dummy-header-cell"
                    header="項目"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額str"
                    width={128}
                    isReadOnly={true}
                    cssClass="number-col read-only-cell"
                    header="金額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="報告テキスト１"
                    width={400}
                    wordWrap={true}
                    cssClass="read-only-cell"
                    multiLine={true}
                    header="当月売上動向"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="報告テキスト２"
                    width={400}
                    wordWrap={true}
                    multiLine={true}
                    cssClass="read-only-cell"
                    header="見込み"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
            {/* 合計カード */}
            <Card>
              <Spinner searching={isSearching}></Spinner>
              <Card.Body>
                <FlexGridOuter
                  flexGrid={mikomiFlexGrid}
                  gridProperties={{
                    allowAddNew: false,
                    allowDelete: false,
                    showMarquee:
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT.showMarquee,
                    keyActionTab:
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT.keyActionTab,
                    alternatingRowStep:
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                        .alternatingRowStep,
                    selectionMode:
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                        .selectionMode,
                    headersVisibility: wjGrid.HeadersVisibility.Column,
                    width: CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT.width,
                    mergeManager: new mikomiRestrictedMergeManager(),
                    itemFormatter: (
                      panel: wjGrid.GridPanel,
                      r: number,
                      c: number,
                      cell: HTMLElement
                    ) => {
                      if (panel.cellType === wjGrid.CellType.ColumnHeader) {
                        cell.style.textAlign = "center"
                      }
                    },
                    allowSorting: false,
                    allowFiltering: false,
                    autoRowHeights: true,
                  }}
                  setFlexGrid={setMikomiFlexGrid}
                  gridData={mikomiGridData}
                  setGridData={setMikomiGridData}
                  pageNumber={pageNumber}
                  gridId={`${gridId}_2`}
                  isRestoreSearching={isRestoreSearching}
                  setIsRestoreSearching={setIsRestoreSearching}
                  gridInitialized={gridInitialized}
                  setGridInitialized={setGridInitialized}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  isShowGridFooter={false}
                  isShowGridRowPickupButton={false}
                  hasFilter={false}
                  gridInitializedHandler={mikomiGridInitializedHandler}>
                  <wjrGrid.FlexGridColumn
                    binding="見込"
                    align="center"
                    isReadOnly={true}
                    cssClass="dummy-header-cell"
                    width={192}
                    header="見込"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="項目"
                    width={100}
                    isReadOnly={true}
                    cssClass="dummy-header-cell"
                    header="項目"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="金額"
                    width={128}
                    cssClass="number-col"
                    header="金額"></wjrGrid.FlexGridColumn>
                  <wjrGrid.FlexGridColumn
                    binding="見込事由"
                    width={800}
                    wordWrap={true}
                    multiLine={true}
                    header="見込事由"></wjrGrid.FlexGridColumn>
                </FlexGridOuter>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="search-button">
          <Col xl={{ span: "auto", offset: 0 }}>
            {isSubmit && (
              <Button
                type="submit"
                variant="waiting"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  beforeSubmit()
                }}>
                更新
              </Button>
            )}
          </Col>
          <Col>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </>
  )
}

export default WeeklyReportBusyoList
